import React from "react";

import styles from "../Pages/Exp.module.css";

function Exp() {
  return (
            <section id="experience" className={styles.maincontainer}>
                 <div className={styles.recent}>
                    <h2>EXPERIENCE</h2>
                    <h2 className={styles.pro}>FRESHER</h2>
                  </div>
                  <div className={styles.expone}>
                    <h3 className={styles.exphead}>INOVIUM AI </h3>
                      {/* <p className={styles.exppara}>Collaborated with the Innovium.ai team as a freelance front-end developer, contributing to the design and
                      development of user-centric responsive interfaces using React frameworks and UI best practices</p> */}
                      <p className={styles.exppara}>Handled both frontend and backend development, designing responsive user interfaces using React and
                      implementing Flask APIs, authentication, and database integration for dynamic functionality.</p>
                      <p className={styles.expnum}>APRIL 2025 - JULY 2025 </p>
                
                  </div>
                  <div className={styles.expone}>
                    <h3 className={styles.exphead}>8QUEENS</h3>
                    <p className={styles.exppara}>Gained hands-on experience with key Machine Learning algorithms such as Linear Regression, Logistic
                    Regression, Decision Trees, and K-Means Clustering.</p>
                    <p className={styles.expnum}>SEP 2025 - OCT 2025</p>
                
                  </div>
                  
              <div className={styles.expone}>
                    <h3 className={styles.exphead}>DEFFO TECH PRIVATE LIMITED</h3>
                    <p className={styles.exppara}>Built and trained Large Language Models (LLMs) from scratch, including dataset preparation, tokenizer development, transformer implementation, and model optimization.
                      Developed custom Tamil NLP models and datasets, and built AI applications using RAG, AI agents, prompt engineering, and custom language models.
                    </p>
                    <p className={styles.expnum}>MARCH 2026 - AUG 2026</p>
                
                  </div>
            </section>

  )}

  export default Exp;
